import { useRef, useState, useEffect } from "react";
import { FaPlay, FaPause, FaRedo } from "react-icons/fa";

interface VideoPlayerProps {
  src: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (isEnded) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setIsEnded(false);
      setIsPlaying(true);
      return;
    }

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      setIsEnded(true);
      setIsPlaying(false);
    };

    video.addEventListener("ended", handleEnded);
    return () => {
      video.removeEventListener("ended", handleEnded);
    };
  }, []);

  return (
    <div className="relative w-full max-w-full mx-auto overflow-hidden">
      <video
        ref={videoRef}
        src={src}
        className="w-full h-auto"
        controls={false}
        preload="metadata"
      />
      <button
        onClick={togglePlay}
        className="absolute bottom-4 left-4 size-11 rounded-full bg-gray-700 text-white flex items-center justify-center shadow-card hover:bg-black transition"
      >
        {isEnded ? <FaRedo /> : isPlaying ? <FaPause /> : <FaPlay />}
      </button>
    </div>
  );
};

export default VideoPlayer;
